import { IsOptional, IsUUID } from 'class-validator';

export class SendXdis91Dto {
  @IsOptional()
  @IsUUID()
  conditionId?: string;

  @IsOptional()
  @IsUUID()
  /** @deprecated Use conditionId */
  skinConditionId?: string;
}
export interface SendXdis91ResultDto {
  success: boolean;
}
